/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `Odkaz na dodavatele`
};

const da_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `Producent SKU`
};

const de_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `Hersteller SKU`
};

const en_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `Manufacturer SKU`
};

const es_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `Referencia del proveedor`
};

const fr_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `Référence fournisseur`
};

const hu_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `Gyártó Sku`
};

const it_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `Costruttore SKU`
};

const nl_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `Fabrikant SKU`
};

const pl_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `SKU producenta`
};

const pt_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `Fabricante SKU`
};

const sv_attributes_manufacturer_sku = /** @type {(inputs: {}) => string} */ () => {
	return `Tillverkarens SKU`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_manufacturer_sku = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_manufacturer_sku(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_manufacturer_sku", locale)
	if (locale === "cs") return cs_attributes_manufacturer_sku(inputs)
	if (locale === "da") return da_attributes_manufacturer_sku(inputs)
	if (locale === "de") return de_attributes_manufacturer_sku(inputs)
	if (locale === "en") return en_attributes_manufacturer_sku(inputs)
	if (locale === "es") return es_attributes_manufacturer_sku(inputs)
	if (locale === "fr") return fr_attributes_manufacturer_sku(inputs)
	if (locale === "hu") return hu_attributes_manufacturer_sku(inputs)
	if (locale === "it") return it_attributes_manufacturer_sku(inputs)
	if (locale === "nl") return nl_attributes_manufacturer_sku(inputs)
	if (locale === "pl") return pl_attributes_manufacturer_sku(inputs)
	if (locale === "pt") return pt_attributes_manufacturer_sku(inputs)
	return sv_attributes_manufacturer_sku(inputs)
};
export { attributes_manufacturer_sku as "attributes.manufacturer_sku" }